// This is used for axios interceptor
// Cause in that useSnackbar is not used it is only used in component level.
import React from 'react';
import ReactDOM from 'react-dom';
import { useSnackbar } from 'notistack';
import NotistackProvider from './fl-components/NotistackProvider';

export default {
  toast(msg, variant) {
    const Display = ({ message, variant }) => {
      const { enqueueSnackbar } = useSnackbar();
      enqueueSnackbar(message, variant);
    };
    const mountPoint = document.getElementById('snackbarhelper');
    ReactDOM.render(
      <NotistackProvider>
        <Display message={msg} variant={variant} />
      </NotistackProvider>,
      mountPoint
    );
  }
};
